import PropTypes from 'prop-types';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import useConfig from '../hooks/useConfig';
import CustomButton from './CustomButton';
import useGetVehicle from '../hooks/useGetVehicle';

const WhatsappButton = ({ className }) => {
  const { copies } = useConfig();
  const { vehicle } = useGetVehicle();
  const [text, setText] = useState('');

  const { whatsappNumber } = vehicle.seller;

  // find a way to make correctly the url (like window.location) from ssr and remove this effect
  useEffect(() => {
    const url = typeof window === 'undefined' ? '' : window.location;
    setText(copies.defaultWhatsappMessage.replace('{{url}}', url));
  }, [copies.defaultWhatsappMessage]);

  if (!whatsappNumber) return null;

  const url = new URL(`https://wa.me/${whatsappNumber}`);
  url.searchParams.set('text', text);

  return (
    <div>
      <CustomButton
        id="whatsappButton"
        variant="contained"
        size="large"
        color="whatsapp"
        href={url.toString()}
        target="_blank"
        startIcon={<Image src="/whatsapp-icon.svg" alt="whatsapp" width="25" height="25" />}
        className={className}
        onClick={() => dataLayer && dataLayer.push({ event: 'whatsapp-button-click' })}
      >
        Whatsapp
      </CustomButton>
    </div>
  );
};

WhatsappButton.propTypes = {
  className: PropTypes.string,
};

WhatsappButton.defaultProps = {
  className: '',
};

export default WhatsappButton;
